module.exports = __webpack_public_path__ + "viaplay-7d0c4200f46b936410b3894e5ccdaa5c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logos/viaplay.png
// module id = 1060
// module chunks = 0 1